import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchUnsubscribeStatus,
  unsubscribeWithToken,
  type UnsubscribeStatus,
} from '@/api/broadcasts/unsubscribeApi';
import { UNSUBSCRIBE_STATUS_QUERY_KEY } from '@/constants/queryKeys';

export function useUnsubscribeStatusQuery(token: string): UseQueryResult<UnsubscribeStatus, Error> {
  return useQuery({
    queryKey: [...UNSUBSCRIBE_STATUS_QUERY_KEY, token],
    queryFn: function loadStatus() {
      return fetchUnsubscribeStatus(token);
    },
    enabled: token.length > 0,
    retry: false,
  });
}

export function useUnsubscribeMutation(
  token: string
): UseMutationResult<UnsubscribeStatus, Error, void> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function submitUnsubscribe() {
      return unsubscribeWithToken(token);
    },
    onSuccess: function storeStatus(status) {
      queryClient.setQueryData([...UNSUBSCRIBE_STATUS_QUERY_KEY, token], status);
    },
  });
}
